import React, { useState } from 'react';
import axios from 'axios';
import { Plus, ChevronDown } from 'lucide-react';

function AddStockForm({ userId, locationOptions, onSuccess }) {
  const [sku, setSku] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [quantity, setQuantity] = useState('');
  const [loading, setLoading] = useState(false);
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!sku.trim() || !selectedLocation || Number(quantity) === 0) {
      return alert('SKU, ubicación y cantidad son requeridos');
    }

    setLoading(true);
    try {
      const payload = {
        user_id: userId,
        product_sku: sku.trim(),
        location_id: selectedLocation.id,
        quantity: Number(quantity),
        transaction_type: 'MANUAL'
      };

      const baseUrl = process.env.REACT_APP_API_URL || '';
      const res = await axios.post(`${baseUrl}/api/add_stock`, payload);
      
      alert(`Éxito: ${res.data.message}\nNueva cantidad: ${res.data.new_quantity}`);
      setSku('');
      setSelectedLocation(null);
      setQuantity('');
      onSuccess();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Error al agregar stock');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-slate-900 font-montserrat flex items-center gap-2">
          <Plus className="w-5 h-5 text-[#B1336E]" />
          Agregar Stock
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-semibold text-slate-700 font-montserrat mb-2">
              SKU del Producto *
            </label>
            <input
              type="text"
              value={sku}
              onChange={(e) => setSku(e.target.value)}
              placeholder="SKU"
              className="w-full px-3 py-2 border-2 border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-slate-700 font-montserrat mb-2">
              Ubicación *
            </label>
            <div className="relative">
              <button
                type="button"
                onClick={() => setShowLocationDropdown(!showLocationDropdown)}
                className="w-full px-3 py-2 border-2 border-slate-300 rounded-lg text-left focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat text-sm flex items-center justify-between"
              >
                <span className={selectedLocation ? 'text-slate-900' : 'text-slate-400'}>
                  {selectedLocation ? selectedLocation.name : 'Selecciona ubicación'}
                </span>
                <ChevronDown className="w-4 h-4 text-slate-400" />
              </button>

              {showLocationDropdown && (
                <div className="absolute z-10 mt-2 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  {locationOptions.map((loc) => (
                    <button
                      key={loc.id}
                      type="button"
                      onClick={() => {
                        setSelectedLocation(loc);
                        setShowLocationDropdown(false);
                      }}
                      className="w-full text-left px-3 py-2 hover:bg-slate-50 font-montserrat text-sm text-slate-700"
                    >
                      {loc.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-slate-700 font-montserrat mb-2">
              Cantidad *
            </label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              placeholder="0"
              className="w-full px-3 py-2 border-2 border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat text-sm"
              required
            />
          </div>
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="submit"
            disabled={loading}
            className="flex-1 bg-gradient-to-r from-[#B1336E] to-[#E6B43C] text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-montserrat"
          >
            {loading ? 'Guardando...' : 'Agregar Stock'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddStockForm;